import { CommonModule } from '@angular/common';
import { ChangeDetectorRef } from '@angular/core';
import { UiIconsModule } from '../icons';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../icons/icon.component";
const _c0 = ["*"];
function UiMessageComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r0.getIconName())("size", ctx_r0.iconSize);
  }
}
export let UiMessageComponent = /*#__PURE__*/(() => {
  class UiMessageComponent {
    set _type(input) {
      this.type = input;
    }
    constructor(cd) {
      this.cd = cd;
      this.type = 'info';
      this.icon = 'info';
      this.compact = false;
      this.showIcon = true;
      this.noMargin = false;
      this.smallMargin = false;
      this.styleClass = '';
      this.iconSize = 'md';
    }
    getStyleClass() {
      let styleClass = 'p-message ' + this.styleClass;
      let styleName = this.type;
      if (styleName === 'danger') styleName = 'error';else if (styleName === 'warning') styleName = 'warn';
      styleClass += ` p-message-${styleName}`;
      return styleClass;
    }
    getIconName() {
      let msgType = this.type;
      if (msgType === 'danger') msgType = 'error';else if (msgType === 'warning') msgType = 'warn';
      if (msgType === 'warn') return 'exclamation-triangle';
      if (msgType === 'error') return 'times';
      if (msgType === 'success') return 'check';
      return 'info-circle';
    }
    static {
      this.ɵfac = function UiMessageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiMessageComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiMessageComponent,
        selectors: [["ui-message"]],
        hostVars: 6,
        hostBindings: function UiMessageComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("compact", ctx.compact)("remove-margin", ctx.noMargin)("small-margin", ctx.smallMargin);
          }
        },
        inputs: {
          _type: [0, "type", "_type"],
          compact: "compact",
          showIcon: "showIcon",
          noMargin: "noMargin",
          smallMargin: "smallMargin",
          styleClass: "styleClass",
          iconSize: "iconSize"
        },
        ngContentSelectors: _c0,
        decls: 4,
        vars: 2,
        consts: [[3, "ngClass"], [1, "icon", 3, "icon", "size"]],
        template: function UiMessageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵconditionalCreate(1, UiMessageComponent_Conditional_1_Template, 1, 2, "ui-icon", 1);
            i0.ɵɵelementStart(2, "div");
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.getStyleClass());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showIcon ? 1 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, UiIconsModule, i2.UiIconComponent],
        styles: [".icon[_ngcontent-%COMP%]{float:left;margin:0 10px 0 0}\n\n/*# sourceMappingURL=message.ts-angular-inline--19.css.map*/", ".p-message[_ngcontent-%COMP%]{margin:0;padding:15px;text-align:left}\n\n/*# sourceMappingURL=message.ts-angular-inline--20.css.map*/", ".compact[_nghost-%COMP%]   .p-message[_ngcontent-%COMP%]{margin:0;padding:$messagePadding}\n\n/*# sourceMappingURL=message.ts-angular-inline--21.css.map*/", "[_nghost-%COMP%]{margin:20px 0;display:block}\n\n/*# sourceMappingURL=message.ts-angular-inline--22.css.map*/", "[_nghost-%COMP%]:first-child{margin-top:0}\n\n/*# sourceMappingURL=message.ts-angular-inline--23.css.map*/", "[_nghost-%COMP%]:last-child{margin-bottom:0}\n\n/*# sourceMappingURL=message.ts-angular-inline--24.css.map*/", ".small-margin[_nghost-%COMP%]{margin:10px 0}\n\n/*# sourceMappingURL=message.ts-angular-inline--25.css.map*/", ".remove-margin[_nghost-%COMP%]{margin:0}\n\n/*# sourceMappingURL=message.ts-angular-inline--26.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return UiMessageComponent;
})();